
export function stringToHash(string) {
    let hash = 0;

    if (string.length === 0) return hash;

    for (let i = 0; i < string.length; i++) {
        const char = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash |= 0; // Convert to 32bit integer
    }

    return Math.abs(hash);
}

export default function useProfilePicture(username, url) {
    if (!username || !url) {
        return false;
    }
    if (!url) {
        const hash = stringToHash(username);
        const index = hash % 31;
        const items = ["9xGEa8KUb6W4", "4MSETI9fOmxc", "gnK1XzuNE0N0", "9mOAH39xKBGy", "RtDvyG7u95eY", "siSaYfKG0ihy", "ZtHdwWmIeOlv", "lumfMG4MrADA", "wDI77RaxmyWa", "ivaqoxYJdebV", "kbkWzE94YqtT", "oF99FnoyOLzZ", "IQnAMivHBC3w", "RfjNN4e4mxQN", "WgU6NRrWQdss", "0eddfseCTYTR", "jnnOXRNyrMHo", "MxczjBKZjP88", "8w2A4WNqjbUU", "qqhkPhk4dclo", "oTQNwhPuPtLg", "vePfdpgLguUJ", "lNFDmVbjXBaC", "IZzhS8jgZH2L", "EOMrZzKXIZ5M", "lg7wyoIHQTOX", "3x9KJ1SlxQkn", "lchhqpkTs3gI", "LFS6QVY7cuuo", "2vEqapS2IIqo", "8D1T8nNZFres", "PML5V4tWS7Jx", "5FSHkHYCXr9U", "UZxpQK9y9I7M", "mlFjoi7YAmrF", "4kLmQzhpQyl5", "FFHo28SRgwx7", "Sy1eyCKZ3UKK", "EnTjDGgsIojg", "SzIfop0ZUmyU", "DpjE3UXovOfE", "FjmopLgxZk0R", "26BtQqlJ9vAl", "wxr1fJK3wJvP", "O8SK1iv2YhDl",];
        return `https://media.scored.co/profile/${items[index]}.jpg`;
    }
    return `https://media.scored.co/profile/${url}.jpg`;
}